import React from 'react'

const SvgClownFaceOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 20.25c3.314 0 6.25-2.936 6.25-6.25S15.314 7.75 12 7.75 5.75 10.686 5.75 14s2.936 6.25 6.25 6.25zM12 22a8 8 0 100-16 8 8 0 000 16z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.5 4.063a2 2 0 00-1.195 3.813l2.765 2.652A2 2 0 1020 8a2 2 0 10-2-2 2 2 0 00-1.5-1.937zM7.5 4.063a2 2 0 011.195 3.813L5.93 10.528A2 2 0 014 12a2 2 0 110-4 2 2 0 112-2 2 2 0 011.5-1.937z'
    />
    <path d='M15 11l1 2-1 2-1-2 1-2zM9 11l1 2-1 2-1-2 1-2zM13.667 15.917a1.667 1.667 0 11-3.334 0 1.667 1.667 0 013.334 0z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.968 16.334a1.667 1.667 0 10-2.603 2.083c2.334 2.917 6.936 2.917 9.27 0a1.667 1.667 0 10-2.603-2.083c-1 1.25-3.064 1.25-4.064 0zm-.976.781a.417.417 0 00-.65.52c1.833 2.293 5.483 2.293 7.317 0a.417.417 0 00-.651-.52c-1.5 1.875-4.516 1.875-6.016 0z'
    />
  </svg>
)

export default SvgClownFaceOutline
